// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-width .v-snack__wrapper.v-sheet.theme--dark {\n  min-width: 300px;\n}\n.tag-name {\n  letter-spacing: 1px;\n  cursor: pointer;\n  font-size: 14px;\n  background-color: #e4eaf0;\n}\n", ""]);
// Exports
module.exports = exports;
